module.exports = __webpack_public_path__ + "static/media/ic_pencil_black.4ba76e9c.png";